function calculate_mortge_payment(data) {
  const price = data.price;
  let downpayment_price = data.downpayment_price;
  let loanrate = Math.abs(data.loanrate);
  let loanterm = Math.abs(data.loanterm);
  if (downpayment_price > price) {
    downpayment_price = 0;
  }
  if (isNaN(loanrate) || loanrate < 0 || loanrate > 100) {
    loanrate = 4;
  }
  if (isNaN(loanterm)) {
    loanterm = 30;
  }
  const amount_borrowed = price - downpayment_price;
  const num_payments = loanterm * 12;
  const monthly_interest = loanrate / 1200;
  let compounded_interest = 1;
  for (let i = 0; i < num_payments; ++i) {
    compounded_interest *= (1 + monthly_interest);
  }
  const payment = (amount_borrowed * compounded_interest * monthly_interest) /
      (compounded_interest - 1);
  return {
    downpayment_price,
    loanrate,
    loanterm,
    payment,
  };
}

function calculate_downpayment(data) {
  const price = data.price;
  let downpayment_percent = data.downpayment_percent;
  let downpayment_price = data.downpayment_price;
  if (downpayment_percent > 0 && downpayment_price === 0) {
    downpayment_price = Math.round(price * (downpayment_percent / 100));
  } else if (downpayment_percent === 0 && downpayment_price > 0) {
    downpayment_percent = Math.round((downpayment_price * 100) / price);
  }
  return {
    downpayment_percent,
    downpayment_price,
  };
}

function format_number(number) {
  return number.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,');
}

function parse_value(elem) {
  return parseInt($(elem).val().replace(/[^0-9]+/g, ''), 10);
}

function calculate() {
  const data = {
    price: parse_value($('#mortgage-price')),
    downpayment_price: parse_value($('#mortgage-downpayment-price')),
    loanrate: parseFloat($('#mortgage-loanrate').val(), 10),
    loanterm: parse_value($('#mortgage-loanterm')),
  };
  const result = calculate_mortge_payment(data);
  if (!isNaN(result.payment)) {
    $('.property-mortgage-result').text('$' + format_number(result.payment));
  }
}

export function initalize() {
  $('.calculate-mortgage').click(function() {
    $(this).hide();
    $('.property-mortgage').slideDown();
    $('#mortgage-price, #mortgage-downpayment-price')
      .focus(function() {
        $(this).val($(this).val().replace(/[^0-9]+/g, ''));
      })
      .blur(function() {
        const price = parse_value(this);
        $(this).val(format_number(price));
      });
    const $real_price = $('#mortgage-price');
    const $price = $('#mortgage-downpayment-price');
    const $percent = $('#mortgage-downpayment-percent');
    $('#mortgage-downpayment-price').blur(() => {
      const data = calculate_downpayment({
        price: parse_value($real_price),
        downpayment_price: parse_value($price),
        downpayment_percent: 0,
      });
      $percent.val(data.downpayment_percent);
    });
    $('#mortgage-downpayment-percent').blur(() => {
      const data = calculate_downpayment({
        price: parse_value($real_price),
        downpayment_price: 0,
        downpayment_percent: parseFloat($percent.val(), 10),
      });
      $price.val(format_number(data.downpayment_price));
    });
    $('input, select').change(() => setTimeout(calculate, 50));
    calculate();
  });
  $('.property-mortgage-cancel').click(() => {
    $('.property-mortgage').slideUp(400, () => {
      $('.calculate-mortgage').show();
    });
  });
}
